module.exports = __webpack_public_path__ + "static/img/img-aboutus-02.f50cb4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img-aboutus-02.png
// module id = P0ow
// module chunks = 1